module.exports = __webpack_public_path__ + "img/s6-title.8b5fc3cf.png";